import type { TimeFormat } from '@/state/types';

/** Format euros with German thousand separators, no decimals. */
export function formatEuro(amount: number): string {
  return `${Math.round(amount).toLocaleString('de-DE')} €`;
}

/** Format a ms timestamp as HH:MM in local time, respecting timeFormat. */
export function formatClock(ms: number, format: TimeFormat = '24h'): string {
  const d = new Date(ms);
  const minutes = String(d.getMinutes()).padStart(2, '0');
  if (format === '12h') {
    const h24 = d.getHours();
    const period = h24 >= 12 ? 'PM' : 'AM';
    const h12 = h24 % 12 === 0 ? 12 : h24 % 12;
    return `${h12}:${minutes} ${period}`;
  }
  return `${String(d.getHours()).padStart(2, '0')}:${minutes}`;
}

/** Format a short date like 24.04. */
export function formatShortDate(ms: number): string {
  const d = new Date(ms);
  return `${String(d.getDate()).padStart(2, '0')}.${String(d.getMonth() + 1).padStart(2, '0')}.`;
}
